<template>
  <div
    class="body-1 pb-24 lg:pb-0"
    data-qa="orderline-card-content-express-replacement-complete"
    data-test="orderline-card-content-express-replacement-complete"
  >
    <p class="mb-24">
      {{ i18n(translations.paragraph1) }}
    </p>

    <p class="mb-24">
      {{ i18n(translations.paragraph2) }}
    </p>

    <RevLink target="_blank" :to="expressReplacementFaqArticleLink">
      {{ i18n(translations.faqLinkLabel) }}
    </RevLink>
  </div>
</template>

<script lang="ts" setup>
import { useRuntimeConfig } from '#imports'

import { useIntercomHelpCenterBaseUrl } from '@backmarket/nuxt-layer-base/composables/useIntercomHelpCenterBaseUrl'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { RevLink } from '@ds/components/Link'

import { isConfigDefined } from '~/scopes/care-commons/utils/isConfigDefined'

import translations from './OrderlineCardExpressReplacementComplete.translations'

const i18n = useI18n()
const { INTERCOM_HELP_CENTER_ARTICLE_EXPRESS_REPLACEMENT } =
  useRuntimeConfig().public
const { intercomHelpCenterBaseUrl } = useIntercomHelpCenterBaseUrl()

const expressReplacementFaqArticleLink = toNuxtLink({
  type: 'external',
  href: `${intercomHelpCenterBaseUrl}articles/${isConfigDefined(INTERCOM_HELP_CENTER_ARTICLE_EXPRESS_REPLACEMENT, 'INTERCOM_HELP_CENTER_ARTICLE_EXPRESS_REPLACEMENT')}`,
})
</script>
